import swal from 'sweetalert'
import { privateAPI } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'
import * as generalTypes from '../types/generalTypes'

export const getVendorPromotions = (type) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/get-vendor-promotions`, {
      data: { type },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: generalTypes.VENDOR_PROMOTIONS,
        payload: resp,
      })
      // return res.data.discounts;
    }
  }
}

export const createPromotion = (payload) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/create-promotion`, {
      data: { ...payload },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch(getVendorPromotions())
      swal('', resp.message, 'success')
    }
  }
}

export const togglePromotion = (promotionId, status) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/toggle-promotion-status`, {
      data: {
        promotionId,
        status,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch(getVendorPromotions())
      swal('', resp.message, 'success')
    }
  }
}
